import React from 'react';

const Layout = ({ children, gameState, refreshGameState }) => {
  return (
    <div className="game-container custom-scrollbar">
      <div className="floating-particles" id="particles"></div>
      {children}
    </div>
  );
};

export default Layout;
